import gettext from '@sdk/lang/gettext';
import formatTime from '@sdk/utils/dateFormat/formatTime';
import type { TimeBlockExtended } from '@sdk/dayParts/types';

type NewTimeBlock = {
  breakDuration?: number;
  dtstart: Date;
  dtend: Date;
  start: string; // '09:00';
  end: string; // "17:00"
  locations: Array<{ id: number; name: string }>;
};

export const extendNewTimeBlock = (timeBlock: NewTimeBlock): TimeBlockExtended => {
  const extended: any = {
    ...timeBlock,
    deleted: false,
    duration: ((timeBlock.dtend as any) - (timeBlock.dtstart as any)) / 1000 / 60 / 60,
    time: `${formatTime(timeBlock.dtstart)} - ${formatTime(timeBlock.dtend)}`,
  };

  if (extended.duration === 0) {
    extended.durationLabel = gettext('24 hours');
  } else {
    extended.durationLabel = gettext(`%(count)s hours`, {
      count: Math.round(extended.duration * 10) / 10,
    });
  }

  if (extended.breakDuration) {
    extended.breakLabel = gettext('%(count)s minutes', { count: extended.breakDuration });
  } else {
    extended.breakLabel = gettext('No break');
  }

  if (extended.locations.length) {
    extended.locationLabel = extended.locations[0].name;
  } else {
    extended.locationLabel = gettext('All locations');
  }

  return extended;
};
